import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useQuery } from "@tanstack/react-query";
import { fetchAllCompanyReports, fetchAllReports } from "../api/report.api";
import { ReportStatus } from "../api/models/report.models";

interface UseReportsProps {
  companyId: number | null;
  organizationId?: number | null | undefined;
  year?: number;
  quarter?: number;
  month?: number;
  reportStatus?: ReportStatus;
  withRows?: boolean;
}

const useReports = ({
  companyId,
  organizationId,
  year,
  quarter,
  month,
  reportStatus,
  withRows,
}: UseReportsProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken]),
  );

  const { data: reportsData, isLoading: isLoadingReports } = useQuery({
    queryKey: [
      "reports",
      companyId,
      organizationId,
      year,
      quarter,
      month,
      reportStatus,
      withRows,
    ],
    queryFn: () =>
      organizationId
        ? fetchAllReports(
            companyId as number,
            organizationId,
            bearerToken,
            withRows,
          )
        : fetchAllCompanyReports(
            companyId as number,
            bearerToken,
            year,
            quarter,
            month,
            reportStatus,
            withRows,
          ),
    enabled: !!companyId,
  });

  return {
    reportsData,
    isLoadingReports,
  };
};

export default useReports;
